/**
 * Item Price DocType-specific translations.
 * Key: `Item Price:${fieldname}`
 * Value: { en: string, th: string }
 */
export const itemPriceTranslations: Record<string, { en: string; th: string }> = {
  // Basic identification fields
  "Item Price:name": { en: "Item Price ID", th: "รหัสราคาสินค้า" },
  "Item Price:item_code": { en: "Item Code", th: "รหัสสินค้า" },
  "Item Price:item_name": { en: "Item Name", th: "ชื่อสินค้า" },
  "Item Price:brand": { en: "Brand", th: "แบรนด์" },
  "Item Price:description": { en: "Description", th: "รายละเอียด" },
  
  // Pricing fields
  "Item Price:price_list": { en: "Price List", th: "รายการราคา" },
  "Item Price:currency": { en: "Currency", th: "สกุลเงิน" },
  "Item Price:price_list_rate": { en: "Rate", th: "อัตรา" },
  "Item Price:uom": { en: "UOM", th: "หน่วย" },
  "Item Price:packing_unit": { en: "Packing Unit", th: "หน่วยบรรจุ" },
  
  // Type fields
  "Item Price:buying": { en: "Buying", th: "ซื้อ" },
  "Item Price:selling": { en: "Selling", th: "ขาย" },
  
  // Validity fields
  "Item Price:valid_from": { en: "Valid From", th: "ใช้ได้ตั้งแต่" },
  "Item Price:valid_upto": { en: "Valid Upto", th: "ใช้ได้จนถึง" },
  
  // Context fields
  "Item Price:customer": { en: "Customer", th: "ลูกค้า" },
  "Item Price:supplier": { en: "Supplier", th: "ผู้ขาย" },
  "Item Price:batch_no": { en: "Batch No", th: "หมายเลขล็อต" },
  
  // Additional fields
  "Item Price:lead_time_days": { en: "Lead Time Days", th: "ระยะเวลารอคอย (วัน)" },
  "Item Price:note": { en: "Note", th: "หมายเหตุ" },
};

